export const ROUTE_META = {
  "/concepts": { component: "Concepts", title: "Website Concepts | Thrivehaus Digital", description: "Explore fictional website design studies and try their features.", noindex: true },
  "/concepts/table-01": { component: "ConceptDemo", title: "Table / 01 — Design Concept | Thrivehaus Digital", description: "Fictional website design study by Thrivehaus Digital.", noindex: true },
  "/concepts/field-02": { component: "ConceptDemo", title: "Field / 02 — Design Concept | Thrivehaus Digital", description: "Fictional website design study by Thrivehaus Digital.", noindex: true },
  "/concepts/form-03": { component: "ConceptDemo", title: "Form / 03 — Design Concept | Thrivehaus Digital", description: "Fictional website design study by Thrivehaus Digital.", noindex: true },
  "/concepts/works-04": { component: "ConceptDemo", title: "Works / 04 — Design Concept | Thrivehaus Digital", description: "Fictional website design study by Thrivehaus Digital.", noindex: true },
  "/concepts/shift-05": { component: "ConceptDemo", title: "Shift / 05 — Design Concept | Thrivehaus Digital", description: "Fictional website design study by Thrivehaus Digital.", noindex: true },
  "/concepts/scope-06": { component: "ConceptDemo", title: "Scope / 06 — Design Concept | Thrivehaus Digital", description: "Fictional website design study by Thrivehaus Digital.", noindex: true },

  "/": {
    component: "Home",
    label: "Home",
    title: "Thrivehaus Digital | Websites, SEO & Digital Systems",
    description:
      "Adelaide-based digital studio for custom websites, SEO, AI search optimisation and automation. Premium responsive builds with packages from A$399.",
  },
  "/adelaide-web-design": {
    component: "AdelaideWebDesign",
    title: "Web Design Adelaide | Custom Websites | Thrivehaus Digital",
    description:
      "Custom web design in Adelaide for businesses that need a fast, responsive website built to generate enquiries. Starter sites from A$399 with SEO foundations included.",
    service: {
      name: "Web Design Adelaide",
      serviceType: "Website design, development and search optimisation",
      localOnly: true,
    },
  },
  "/adelaide/small-business-web-design-adelaide": {
    component: "AdelaideLocalPage",
    title: "Small Business Web Design Adelaide | Thrivehaus Digital",
    description:
      "Responsive small business websites in Adelaide with clear services, enquiry paths and local search foundations. Builds from A$399.",
    service: {
      name: "Small Business Web Design Adelaide",
      serviceType: "Website design",
      localOnly: true,
    },
  },
  "/adelaide/seo-adelaide": {
    component: "AdelaideLocalPage",
    title: "SEO Adelaide | Search Optimisation | Thrivehaus Digital",
    description:
      "Technical SEO, useful service content and local search foundations for Adelaide businesses.",
    service: {
      name: "SEO Adelaide | Search Optimisation",
      serviceType: "Search engine optimisation",
      localOnly: true,
    },
  },
  "/adelaide/restaurant-web-design-adelaide": {
    component: "AdelaideLocalPage",
    title: "Restaurant Web Design Adelaide | Thrivehaus Digital",
    description:
      "Restaurant and hospitality websites in Adelaide with readable menus, booking paths and mobile-friendly local discovery.",
    service: {
      name: "Restaurant Web Design Adelaide",
      serviceType: "Website design",
      localOnly: true,
    },
  },
  "/adelaide/tradie-web-design-adelaide": {
    component: "AdelaideLocalPage",
    title: "Tradie Web Design Adelaide | Thrivehaus Digital",
    description:
      "Responsive websites for Adelaide trades with clear services, service areas and simple quote requests.",
    service: {
      name: "Tradie Web Design Adelaide",
      serviceType: "Website design",
      localOnly: true,
    },
  },
  "/adelaide/automotive-web-design-adelaide": {
    component: "AdelaideLocalPage",
    title: "Automotive Web Design Adelaide | Thrivehaus Digital",
    description:
      "Automotive websites in Adelaide for workshops, detailers and dealers, with strong presentation and straightforward enquiries.",
    service: {
      name: "Automotive Web Design Adelaide",
      serviceType: "Website design",
      localOnly: true,
    },
  },
  "/adelaide/ecommerce-web-design-adelaide": {
    component: "AdelaideLocalPage",
    title: "Ecommerce Web Design Adelaide | Thrivehaus Digital",
    description:
      "Responsive ecommerce website design in Adelaide with product discovery, checkout planning and clear customer journeys.",
    service: {
      name: "Ecommerce Web Design Adelaide",
      serviceType: "Ecommerce website design",
      localOnly: true,
    },
  },
  "/adelaide/professional-services-web-design-adelaide": {
    component: "AdelaideLocalPage",
    title: "Professional Services Web Design Adelaide | Thrivehaus Digital",
    description:
      "Professional services websites in Adelaide that explain expertise, build trust and make enquiries easy on every device.",
    service: {
      name: "Professional Services Web Design Adelaide",
      serviceType: "Website design",
      localOnly: true,
    },
  },
  "/services": {
    component: "Services",
    title: "Web Design, SEO & Automation Services | Thrivehaus Digital",
    description:
      "Explore Thrivehaus Digital services: premium website design and development, SEO, AI search optimisation, automation, managed hosting and website care.",
  },
  "/services/website-packages": {
    component: "WebsitePackages",
    title: "Website Packages & Web Design Pricing | Thrivehaus Digital",
    description:
      "Compare Thrivehaus website packages: Starter from A$399, Business from A$1,499, Premium from A$2,499 and Custom. Clear scope, inclusions and SEO foundations.",
    service: {
      name: "Website Design Packages",
      serviceType: "Website design and development packages",
    },
  },
  "/services/support": {
    component: "SupportCare",
    title: "Website Hosting & Care | Thrivehaus Digital",
    description:
      "Managed website hosting, monitoring, updates and ongoing website care from Thrivehaus Digital, with plans from A$79/month.",
    service: {
      name: "Managed Hosting & Website Care",
      serviceType: "Managed website hosting, monitoring and website care",
    },
  },
  "/services/websites": {
    component: "WebsiteDesign",
    title: "Website Design & Development | Thrivehaus Digital",
    description:
      "Custom website design and development for businesses of all sizes, responsive across mobile, tablet, laptop and desktop, with performance and technical QA.",
    service: {
      name: "Website Design & Development",
      serviceType: "Website design and development",
    },
  },
  "/services/seo": {
    component: "ServicePage",
    title: "SEO Optimisation | Thrivehaus Digital",
    description:
      "Technical and on-page SEO, local search foundations, content structure and search optimisation designed around genuine customer intent.",
    service: {
      name: "SEO Optimisation",
      serviceType: "Search engine optimisation",
    },
  },
  "/services/ai-search": {
    component: "ServicePage",
    title: "AI Search Optimisation | Thrivehaus Digital",
    description:
      "AI search optimisation that helps search assistants better understand your business, services, locations and useful expertise.",
    service: {
      name: "AI Search Optimisation",
      serviceType: "AI search optimisation",
    },
  },
  "/services/automation": {
    component: "ServicePage",
    title: "Automation & Integrations | Thrivehaus Digital",
    description:
      "Practical website automation and integrations for enquiries, lead routing, CRM workflows, notifications and connected business systems.",
    service: {
      name: "Automation & Integrations",
      serviceType: "Business automation and website integrations",
    },
  },
  "/about": {
    component: "About",
    title: "About Thrivehaus Digital | Adelaide Web Design Studio",
    description:
      "Meet Thrivehaus Digital, an Adelaide-based digital studio combining web design, search visibility, automation, infrastructure and ongoing support.",
  },
  "/work/khim-thai-restaurant": {
    component: "CaseStudyKhimThai",
    title: "Khim Thai Restaurant Case Study | Thrivehaus Digital",
    description:
      "How Thrivehaus Digital built a mobile-first website for Khim Thai Restaurant on Prospect Road, Adelaide: full menu, tap-to-call, directions and local search foundations.",
    image: "/media/case-studies/khim-thai/share.jpg",
    imageAlt: "Khim Thai Restaurant homepage: Hot woks. Fresh herbs. Big plates.",
  },
  "/contact": {
    component: "Contact",
    title: "Contact Thrivehaus Digital",
    description:
      "Talk to Thrivehaus Digital about web design, SEO, AI search optimisation, automation, hosting or ongoing website care.",
  },
  "/privacy": {
    component: "Privacy",
    title: "Privacy | Thrivehaus Digital",
    description: "Read the Thrivehaus Digital privacy information.",
  },
  "/terms": {
    component: "Terms",
    title: "Terms | Thrivehaus Digital",
    description: "Read the Thrivehaus Digital website and service terms.",
  },
};

export const LEGACY_REDIRECTS = {
  "/pricing": "/services/website-packages",
  "/services/development": "/services",
  "/services/hosting-support": "/services/support",
};
export const SITE_URL = "https://thrivehausdigital.com.au";
export function normalizePath(path) {
  return path === "/" ? "/" : path.replace(/\/+$/, "");
}
export function routeFor(path) {
  return ROUTE_META[normalizePath(path)];
}
